import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Input from 'components/input/input';
import Select from 'components/select/select';
import CustomerSelect from 'components/select/customer_select';
import DateTimePicker from 'components/date_time_picker/date_time_picker';
import Textarea from 'components/textarea/textarea';
import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right.svg';
import {
  NEXT_ACTIONS,
  RECORDING_STATUSES,
  STATUSES,
  MANUAL_PAYMENT_STATUSES,
} from 'config/polygraphy';
import {
  customerShape,
  doctorShape,
  optionShape,
  technicianShape,
} from 'helpers/shared_types';

const ViewComponent = ({
  doctorOptions,
  onChange,
  onCustomerChange,
  onDateChange,
  onDoctorSelect,
  onSelectChange,
  onSubmit,
  onTechnicianSelect,
  polygraphy,
  technicianOptions,
  validation,
}) => {
  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header">
          <h2 className="th-canvas-title">
            <Link to="/polygraphies">Polygraphies</Link>
            <span>
              <ArrowRightSVG />
            </span>
            Add
          </h2>
          <section className="view-actions">
            <button
              className="btn-green"
              data-cy="submit"
              onClick={() => onSubmit()}
            >
              Submit
            </button>
          </section>
        </header>
        <div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">Customer</h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column justify-between">
            <div className="w-100 flex flex-column items-start justify-between margin-between">
              <div className="w-100">
                <CustomerSelect
                  className="customer-select"
                  valid={validation.customer}
                  label="Customer*"
                  value={polygraphy.customer}
                  onChange={(selectedOption) =>
                    onSelectChange('customer', selectedOption)
                  }
                />
              </div>
              <div className="w-100 flex-row items-start justify-between margin-between">
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-33">
                    <Input
                      name="phone"
                      label="Phone"
                      value={polygraphy.customer?.phone}
                      valid={validation.customerPhone}
                      onChange={(event) => onCustomerChange(event)}
                    />
                  </div>
                  <div className="w-33">
                    <Input
                      name="email"
                      label="Email"
                      value={polygraphy.customer?.email}
                      valid={validation.customerEmail}
                      onChange={(event) => onCustomerChange(event)}
                    />
                  </div>
                  <div className="w-33">
                    <Input
                      name="city"
                      label="City"
                      value={polygraphy.customer?.city}
                      valid={validation.customerCity}
                      onChange={(event) => onCustomerChange(event)}
                    />
                  </div>
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <Input
                    name="address"
                    label="Address"
                    value={polygraphy.customer?.address}
                    valid={validation.customerAddress}
                    onChange={(event) => onCustomerChange(event)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">Polygraphy</h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
            <div className="w-100 flex flex-column items-start justify-between margin-between">
              <div className="w-100 flex justify-between margin-between">
                <div className="w-50">
                  <Select
                    className="technician-select"
                    valid={validation.technician}
                    isMulti={false}
                    label="Technician"
                    value={polygraphy.technician}
                    options={technicianOptions}
                    onChange={(selectedOption) =>
                      onTechnicianSelect(selectedOption)
                    }
                  />
                </div>
                <div className="w-50">
                  <Select
                    className="doctor-select"
                    valid={validation.doctor}
                    validationText="Please, select a doctor to create the polygraphy"
                    isMulti={false}
                    label="Doctor*"
                    value={polygraphy.doctor}
                    options={doctorOptions}
                    onChange={(selectedOption) =>
                      onDoctorSelect(selectedOption)
                    }
                  />
                </div>
              </div>
              <div className="w-100 flex-row items-start justify-between margin-between">
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-50">
                    <DateTimePicker
                      label="Delivery date"
                      valid={validation.deliveryDate}
                      showTimeInput={true}
                      value={polygraphy.deliveryDate}
                      onChange={(value) =>
                        onDateChange({ field: 'deliveryDate', value })
                      }
                    />
                  </div>
                  <div className="w-50">
                    <DateTimePicker
                      label="Pickup date"
                      valid={validation.pickupDate}
                      showTimeInput={true}
                      value={polygraphy.pickupDate}
                      onChange={(value) =>
                        onDateChange({ field: 'pickupDate', value })
                      }
                    />
                  </div>
                </div>
                <div className="w-100">
                  <Textarea
                    label="PG Notes"
                    name="notes"
                    valid={true}
                    value={polygraphy.notes}
                    onChange={(event) => onChange(event)}
                  />
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-25">
                    <Select
                      className="status-select"
                      valid={validation.polygraphyStatus}
                      isMulti={false}
                      label="Status"
                      value={polygraphy.status}
                      options={STATUSES}
                      onChange={(selectedOption) =>
                        onSelectChange('status', selectedOption)
                      }
                    />
                  </div>
                  <div className="w-25">
                    <Select
                      className="recordingStatus-select"
                      valid={validation.recordingStatus}
                      isMulti={false}
                      label="Recording status"
                      value={polygraphy.recordingStatus}
                      options={RECORDING_STATUSES}
                      onChange={(selectedOption) =>
                        onSelectChange('recordingStatus', selectedOption)
                      }
                    />
                  </div>
                  <div className="w-25">
                    <Select
                      className="nextAction-select"
                      valid={validation.nextAction}
                      isMulti={false}
                      label="Next action"
                      value={polygraphy.nextAction}
                      options={NEXT_ACTIONS}
                      onChange={(selectedOption) =>
                        onSelectChange('nextAction', selectedOption)
                      }
                    />
                  </div>
                  <div className="w-25">
                    <Select
                      className="paymentStatus-select"
                      valid={validation.manualPaymentStatus}
                      isMulti={false}
                      label="Manual payment status"
                      value={polygraphy.manualPaymentStatus}
                      options={MANUAL_PAYMENT_STATUSES}
                      onChange={(selectedOption) =>
                        onSelectChange('manualPaymentStatus', selectedOption)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

ViewComponent.propTypes = {
  doctorOptions: PropTypes.arrayOf(optionShape),
  onChange: PropTypes.func.isRequired,
  onCustomerChange: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onDoctorSelect: PropTypes.func.isRequired,
  onSelectChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onTechnicianSelect: PropTypes.func.isRequired,
  polygraphy: PropTypes.shape({
    nextAction: optionShape,
    manualPaymentStatus: optionShape,
    recordingStatus: optionShape,
    status: optionShape,
    deliveryDate: PropTypes.instanceOf(Date),
    pickupDate: PropTypes.instanceOf(Date),
    technician: technicianShape,
    doctor: doctorShape,
    customer: customerShape,
  }),
  technicianOptions: PropTypes.arrayOf(optionShape),
  validation: PropTypes.shape({
    customer: PropTypes.bool,
    customerPhone: PropTypes.bool,
    customerEmail: PropTypes.bool,
    customerCity: PropTypes.bool,
    customerAddress: PropTypes.bool,
    technician: PropTypes.bool,
    doctor: PropTypes.bool,
    deliveryDate: PropTypes.bool,
    pickupDate: PropTypes.bool,
    polygraphyStatus: PropTypes.bool,
    recordingStatus: PropTypes.bool,
    nextAction: PropTypes.bool,
    manualPaymentStatus: PropTypes.bool,
  }),
};

export default ViewComponent;
